interface AppFooterProps {
  status?: string;
  copyrightText?: string;
  brand?: string;
}

const DEFAULT_COPYRIGHT_YEAR = new Date().getFullYear();

/**
 * Global footer per Jira OOM-1256.
 *
 * Layout (40px tall, full width, fixed bottom):
 *   Left:   status text ("Ready" by default)
 *   Center: copyright
 *   Right:  brand mark / company name
 *
 * Text-based brand placeholder until the official `Footer logo image.svg`
 * asset is provided (tracked as a follow-up to OOM-1256).
 */
export function AppFooter({
  status = 'Ready',
  copyrightText = `© ${DEFAULT_COPYRIGHT_YEAR} AllCAD Solutions FZC. All rights reserved.`,
  brand = 'AllCAD',
}: AppFooterProps): JSX.Element {
  return (
    <footer
      className="grid grid-cols-3 items-center px-6 text-sm"
      style={{
        height: 'var(--app-footer-h)',
        backgroundColor: 'var(--app-bg-alt)',
        borderTop: '1px solid var(--app-border)',
        color: 'var(--app-text-secondary)',
      }}
    >
      <span className="justify-self-start truncate" title={status}>
        {status}
      </span>
      <span className="justify-self-center truncate text-center" title={copyrightText}>
        {copyrightText}
      </span>
      <span
        className="justify-self-end truncate font-semibold"
        style={{ color: 'var(--app-text-primary)' }}
        title={brand}
      >
        {brand}
      </span>
    </footer>
  );
}
